import { render } from "./message-custom.vue?vue&type=template&id=6f6b1448&scoped=true&ts=true"
import script from "./message-custom.vue?vue&type=script&lang=ts"
export * from "./message-custom.vue?vue&type=script&lang=ts"

import "./message-custom.vue?vue&type=style&index=0&id=6f6b1448&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6b1448"]])

export default __exports__